import cx from 'classnames';
import styles from './stats-strip.module.scss';
import type {StatsStripProps} from './types';

const StatsStrip = ({items, className = '', columns = 3}: StatsStripProps) => (
  <div className={cx(styles.strip, {[styles['strip--two-col']]: columns === 2}, className)}>
    {items.map(item => (
      <div key={`${item.value}-${item.label}`} className={styles.item}>
        <div className={styles.value}>{item.value}</div>
        <div className={styles.label}>{item.label}</div>
      </div>
    ))}
  </div>
);

export default StatsStrip;
export type {StatsStripItem, StatsStripProps} from './types';
